import type { ToolbarProps, TooltipProps } from '@mui/material'
import {
  IconButton,
  Stack, Toolbar, useMediaQuery, useTheme,
} from '@mui/material'
import { ButtonEx } from '@xylabs/react-button'
import { FlexGrowRow } from '@xylabs/react-flexbox'
import { LinkEx } from '@xylabs/react-link'
import { useIsDark } from '@xylabs/react-theme'
import { t } from 'i18next'
import React, { useState } from 'react'

import { RotationAnimation } from '../common/index.ts'
import { useIsMobile } from '../hooks/useIsMobile.ts'
import { Images } from '../img/index.ts'
import { DropdownSection } from './Dropdown/index.ts'
import { useNavbarData } from './NavData/index.ts'

export const ContextToolbar: React.FC<ToolbarProps> = (props) => {
  const theme = useTheme()
  const darkMode = useIsDark()
  const isNavbarMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const [navigationController, setNavigationController] = useState<[number, boolean]>([0, false])
  const NavbarData = useNavbarData()
  const isMobile = useIsMobile()

  return (
    <Toolbar {...props} disableGutters>
      <FlexGrowRow>
        <LinkEx to="/" tabIndex={0}>
          <Stack direction="row" paddingRight={1} spacing={0.5} alignItems="center" justifyContent="center" sx={{ direction: 'ltr' }}>
            <RotationAnimation rotation={20}>
              <img src={darkMode ? Images.Logos.XYOIconColor : Images.Logos.XYOIconBlack} height={isNavbarMobile ? 40 : 36} alt="XYO Icon Logo" />
            </RotationAnimation>
            <img src={darkMode ? Images.Logos.XYOTextWhite : Images.Logos.XYOTextBlack} height={24} alt="XYO Text Logo" />
          </Stack>
        </LinkEx>
        <FlexGrowRow>
          {!isNavbarMobile && NavbarData.map((section, index) => (
            <DropdownSection
              dropdownId={index}
              data={section}
              key={section.name}
              open={navigationController[0] === index ? navigationController[1] : false}
              openController={setNavigationController}
              placement={
                index === 0
                  ? ('bottom-start' as TooltipProps['placement'])
                  : index === NavbarData.length - 1
                    ? ('bottom-end' as TooltipProps['placement'])
                    : ('bottom' as TooltipProps['placement'])
              }
            />
          ))}
          {isMobile
            ? (
                null
              )
            : (
                <ButtonEx
                  variant="text"
                  disableTouchRipple
                  paddingY={1}
                  paddingX={1.5}
                  aria-controls="documentation-menu"
                  id="documentation-button"
                  href="https://docs.xyo.network/"
                  target="_blank"
                  sx={{
                    'color': theme.vars.palette.text.primary,
                    '&:hover': {
                      filter: 'none',
                      color: theme.vars.palette.secondary.main,
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  {t('navbar:documentation.title')}
                </ButtonEx>
              )}
        </FlexGrowRow>
      </FlexGrowRow>
    </Toolbar>
  )
}
